// extracted by mini-css-extract-plugin
module.exports = {"primary":"#10b419","accent":"#e91e63","secondary":"#20680e","tertiary":"#34b48e","success":"#287e13","info":"#2196f3","warning":"#cf4f39","danger":"#fb8c00","error":"#e63838"};